import React, { useState } from "react";
import { VendorPayoutResponse } from "../../interfaces/VendorPayout/VendorPayoutResponse";
import { VendorPayoutTransactionStatus } from "../../enums/vendorPayoutTransactionStatus";
import { CustomSnackbarTypes } from "../Common/CustomSnackBar";
import EventBus from "../../EventBus";
import { EventBusEventsEnum } from "../../enums/EventBusEventsEnum";
import TransactionButton from "../Common/TransactionButton";
import VendorPayoutService from "../../services/VendorPayoutService";
import {
  Link,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { CustomTableRowTR, StyledTable, TableData, TableHeader, TableWrapper } from "../../styles/commonStyles";
import { useRefresh } from "react-admin";
import RejectPayoutReasonDialog from "../Common/RejectPayoutReasonDialog";
import { PayoutTypeDailog } from "../Common/payoutTypeDialog";
import { formatDateTimeWithSeconds } from '../../utils/DateTimeUtils';

const vendorPayoutService = new VendorPayoutService();

interface Props {
  data: any;
  updateParentData: () => void;
}

interface ActionButtonsInputProps {
  id: number;
  setPayoutTypeDailog: React.Dispatch<React.SetStateAction<boolean>>;
  data?: VendorPayoutResponse;
  setSelectedData: React.Dispatch<
    React.SetStateAction<VendorPayoutResponse | null>
  >;
  status?: VendorPayoutTransactionStatus;
  updateParentData: () => void;
}

const ApprovePayout = (props: any) => {
  const handleClick = async () => {
    try {
      const response = await vendorPayoutService.approvePayout(
        Number(props?.id)
      );
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: response.status,
        type: CustomSnackbarTypes.SUCCESS,
      });
      props.updateParentData();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <TransactionButton
      onClickHandler={handleClick}
      color="success"
      name={"Approve Payout"}
    />
  );
};

const ProcessPayout = (props: ActionButtonsInputProps) => {
  const handleClick = () => {
    props.setPayoutTypeDailog(true);
    props.setSelectedData(props.data as VendorPayoutResponse);
    props.updateParentData();
  };

  return (
    <TransactionButton onClickHandler={handleClick} name={"Process Payout"} />
  );
};

const RejectPayout = (props: any) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <RejectPayoutReasonDialog open={open} setOpen={setOpen} id={props.id} />
      <TransactionButton
        onClickHandler={() => setOpen(true)}
        color="error"
        name={"Reject Payout"}
      />
    </>
  );
};

const RendorCTAButtons = (props: ActionButtonsInputProps) => {
  return (
    <div>
      {props?.status &&
        [VendorPayoutTransactionStatus.PENDING].includes(props.status) && (
          <>
            <ApprovePayout
              id={props.id}
              key={`approve-${props.id}`}
              updateParentData={props.updateParentData}
            />
            <RejectPayout
              id={props.id}
              key={`reject-${props.id}`}
              updateParentData={props.updateParentData}
            />
          </>
        )}
      {props?.status &&
        [
          VendorPayoutTransactionStatus.APPROVED,
          VendorPayoutTransactionStatus.PROCESSING_FAILED,
        ].includes(props.status) && (
          <ProcessPayout
            id={props.id}
            data={props.data}
            setPayoutTypeDailog={props.setPayoutTypeDailog}
            setSelectedData={props.setSelectedData}
            updateParentData={props.updateParentData}
          />
        )}
    </div>
  );
};

const OneMealServiceVendorMetaShow = (props: Props) => {
  const [payoutTypeDailog, setPayoutTypeDailog] = useState<boolean>(false);
  const [selectedData, setSelectedData] = useState<VendorPayoutResponse | null>(
    null
  );
  const refresh = useRefresh();
  const updateParentData = () => {
    refresh();
  };
  return (
    <div>
      <PayoutTypeDailog
        data={selectedData}
        open={payoutTypeDailog}
        callback={() => {
          setPayoutTypeDailog(false);
        }}
      />
      <TableWrapper>
        <TableContainer component={Paper} sx={{ borderRadius: "8px" }}>
          <StyledTable>
            <TableHead>
              <TableRow sx={{ backgroundColor: "rgba(232,235,237,0.3) !important" }}>
                <TableHeader>Id</TableHeader>
                <TableHeader>Cook Name</TableHeader>
                <TableHeader>Amount</TableHeader>
                <TableHeader>Description</TableHeader>
                <TableHeader>Last Update</TableHeader>
                <TableHeader>Status</TableHeader>
                <TableHeader>Action</TableHeader>
              </TableRow>
            </TableHead>
            <TableBody>
              {props?.data?.map((value: any) => (
                <CustomTableRowTR key={value.id}>
                  <TableData>
                    <Link href={`/#/VendorPayouts/${value.id}/show`}>
                      {value?.id}
                    </Link>
                  </TableData>
                  <TableData>
                    {value?.cook["cookFullProfile"]["firstName"] + " " + value?.cook["cookFullProfile"]["lastName"]}
                  </TableData>
                  <TableData>{value?.amount}</TableData>
                  <TableData>{value?.id}</TableData>
                  <TableData>{formatDateTimeWithSeconds(value?.updatedAt)}</TableData>
                  <TableData>{value?.status}</TableData>
                  <TableData>
                    <RendorCTAButtons
                      id={value.id}
                      status={value.status}
                      data={value}
                      setPayoutTypeDailog={setPayoutTypeDailog}
                      setSelectedData={setSelectedData}
                      updateParentData={() => updateParentData()}
                    />
                  </TableData>
                </CustomTableRowTR>
              ))}
            </TableBody>
          </StyledTable>
        </TableContainer>
      </TableWrapper>
    </div>
  );
};

export default OneMealServiceVendorMetaShow;
